import {useEffect, useState} from "react";
import {Col, Modal, Row} from "react-bootstrap";
import {detectSource} from "../utils/sourceDetection";

function DeclarationPopupTFAF(props) {
    const [enableButton, setEnableButton] = useState(false);
  const baseUrl = window.location.origin;
  const source = detectSource();
  const isVTNZPath = source === 'VTNZ';
  const isAAPath = source === 'AA' || source === 'AA_MEMBER';
  // Push event to GTM when the popup is shown
    useEffect(() => {
        if (props.parentDeclarationPopupShow &&
          (props.source === 'AA' || props.source === 'AA_MEMBER')) {
            // Push virtual pageview event to dataLayer for GTM
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPageview',
                'virtualUrl': '/disclosure',
                'pageTitle': 'Disclosure'
            });
        }
    }, [props.parentDeclarationPopupShow]);

    const handleClose = () => {
        props.setParentDeclarationPopupShow(false);
    };

    const handleCloseAndNext = () => {
        if (!window.location.hostname.includes('aa')) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'mbiAutosureEvent',
            category: 'Disclosure Consent',
            virtualUrl: `${baseUrl}/mbi/step2`,
            pageTitle: 'Choose Your Cover',
          });
        }
        handleClose();
        props.parentNextStep();
    }

    const onChange = (e) => {
        setEnableButton(e.target.checked);
        props.setParentShowDeclStatement(e.target.checked);
    }

    return (<span style={{fontSize: "10px"}}>
      <Modal
          show={props.parentDeclarationPopupShow}
          onHide={handleClose}

          backdrop="static"
          size="lg"
          keyboard={false}
      >
        <Modal.Header closeButton style={{background: '#E5E7EB'}}>
            <Modal.Title className="subHeadingStyles"> Disclosure and Declaration</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{background: 'white'}}>
          <div className="regularTextStyles">
          <span className="popup-text">
            <div>
                <b>The Insurer</b><br/>
            This insurance policy is underwritten by Autosure Insurance Limited (Autosure). Autosure has been given a B++ Financial Strength Rating by A.M. Best.
              <br/> <br/>
              For more information about Autosure’s financial strength rating and solvency margin go to Autosure’s website <a
              href="https://autosure.co.nz" target="_blank" rel="noopener noreferrer"
              style={{color: isAAPath ? '#0d59bf' : '#1851a3'}}>(autosure.co.nz)</a>.
            </div><br/>
              <div>
                 {!props.digimbiEnabled && (<>
                <b>Consumer Guarantees Act 1993 (CGA)</b>
                   <p>Protection under this policy is in addition to your rights under the CGA. The CGA provides that
                     products sold to consumers come with guarantees. The vehicle you have purchased must be of
                     acceptable quality: fit for purpose; durable for as long as most people would expect it to last;
                     free from minor and major faults; and match its description. For more information on your rights as
                     a consumer go to the Commerce Commission’s website (comcom.govt.nz).</p></>)}
                <b>Privacy Policy</b><br/>
              You have acknowledged that:
              <ul>
                <li>We collect personal information about you so that your application for insurance can be assessed and a decision made whether to issue a policy and if so on what terms;</li>
                <li>You authorise us to obtain information regarding names and addresses of registered owners, vehicle information and history from NZ Transport Agency (Waka Kotahi). You authorise this information to be used for the purpose of verifying ownership details of your vehicle. You understand that you have the right to notify Waka Kotahi if you do not wish to have your names and address made available under an authorisation. We hold an Authorisation from Waka Kotahi under section 241(1) of the Land Transport Act 1998;</li>
                <li>Your personal information required to administer your insurance, which is held by any other parties, may be disclosed to us;</li>
                <li>All personal information is securely held by Autosure Insurance Limited, 28 The Warehouse Way, Northcote, Auckland 0627 and may also be securely stored electronically on servers which may be located overseas;</li>
                <li>Under the Privacy Act 2020, you have certain rights of access to, and to request correction of, personal information held about you by us;</li>
                <li>Payments are processed through the secure Windcave Payment Express system. Any credit card details stored for payments are done so on the Windcave system. No credit card information is stored by us and Payment Express protects personal information - at a minimum - to the Payment Card Industry Data Security Standards ("PCI-DSS");</li>
                <li>By providing your email address and phone number, you will receive messages from us about your insurance and, you also consent to us and our related companies sending you marketing messages relating to our products and services, and the products and services of our related group companies, by email and text message; and</li>
              <li>We may share your personal information with our service providers and suppliers, our parent company and our group companies.</li>
              </ul>
              </div>
          <p>
              <b>Duty of Disclosure</b><br/>
            You have a legal duty of disclosure that applies at the time you apply for insurance, when you make changes to your policy and when you make a claim, to tell us everything that a prudent insurer would want to know when deciding whether to provide you with insurance and if so, on what terms, and whether your policy will respond to your claim. If you are not sure whether you should disclose a particular piece of information, please ask. If you breach this duty, we may choose to void your policy from its beginning. This means that your policy will be treated as if it never existed and you will have no cover.
          </p>

          <p>
              <b>Declaration</b><br/>
            By agreeing to proceed, you declare that:
            <ul><li>All of the information you have given during this purchase process is correct and complete, and that all relevant and material information has been disclosed in accordance with your duty of disclosure;</li>
                <li>If this policy was facilitated through an agent, you understand that the agent may receive remuneration for arranging this policy; and</li>
              <li>You agree to accept the terms, conditions, exclusions and definitions of the insurance policy.</li>
              </ul>
          </p>

          <p>
              <label>
            <input type="checkbox"
                   className="form-check-input"
                   checked={enableButton}
                   onChange={onChange}/>&nbsp;&nbsp;
                  <b  style={{ cursor: 'pointer' }}
                      for="">
                  I confirm I understand and agree to this Disclosure and Declaration.</b>
              </label>
          </p>
          <hr/>
          </span>
          <Row>
            <Col>
                 <p
                     style={{
                         display: 'flex',
                         justifyContent: 'space-between',
                         alignItems: "center",
                       paddingTop: '32px',
                       paddingBottom: '50px'
                     }}>
              <button style={{
                color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3',
                  paddingLeft: 25,
                  paddingRight: 25,
                  paddingTop: 13,
                  paddingBottom: 13,
                  background: 'white',
                border: isVTNZPath ? '1px #E87722 solid' : '1px #1851A3 solid',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'inline-flex',
                  wordWrap: 'break-word',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                  width:"100%",
                  maxWidth:"200px"
              }}
                      onClick={handleClose}
                      className="float-left">
                Close
              </button>
              <button  style={{
                  color: 'white',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                  paddingLeft: 25,
                  paddingRight: 25,
                  paddingTop: 13,
                  paddingBottom: 13,
                  overflow: 'hidden',
                border: isAAPath ? '1px #0d59bf solid' : isVTNZPath ? '1px #E87722 solid' : '1px #1851a3 solid',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'inline-flex',
                  width: "100%",
                  maxWidth: "200px",
                background: enableButton ? isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3' : (isVTNZPath ? '#f7e1d0' : '#B0C4DE'),
                  cursor: 'pointer',
              }}
                       onClick={handleCloseAndNext}
                       disabled={!enableButton} className="float-end">
                Next
              </button>
                 </p>
            </Col>
          </Row>
          </div>
        </Modal.Body>
      </Modal>
    </span>);
}

export default DeclarationPopupTFAF;
